// extracted by mini-css-extract-plugin
export default {"cls1":"CMm8m9TL1btQjg3YIdOr","cls2":"swSp7dYHAt4f7Oeak2PG CMm8m9TL1btQjg3YIdOr","isPhone":"_5lPnJVHewx8QQU743Pnw","submitting":"VjopKlOFhoiYy38IUgdA"};